import React from 'react';
import './TrustBar.css';
import company from '../config/company';

const Icon = ({children}) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

const items = [
  {
    id: 'kassen',
    title: 'Alle Kassen',
    text: 'Vertragspartner aller gesetzlichen Pflege- und Krankenkassen',
    icon: <Icon><path d="M9 12l2 2 4-4" /><circle cx="12" cy="12" r="9" /></Icon>
  },
  {
    id: 'rufbereitschaft',
    title: '24h-Rufbereitschaft',
    text: `Tag und Nacht erreichbar: ${company.phone}`,
    icon: <Icon><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" /></Icon>
  },
  {
    id: 'fachkraefte',
    title: 'Examinierte Fachkräfte',
    text: 'Palliativ-Fachkräfte und Wundexpertin im Team',
    icon: <Icon><path d="M12 3l8 4v5c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V7l8-4z" /><path d="M9 12l2 2 4-4" /></Icon>
  },
  {
    id: 'beratung',
    title: 'Pflegeberatung § 37.3',
    text: 'Beratung zu Anträgen, Pflegegrad und Entlastung',
    icon: <Icon><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.4A8 8 0 1 1 21 12z" /></Icon>
  },
  {
    id: 'akademie',
    title: 'Eigene Pflegeakademie',
    text: 'Qualifizierung zum Alltagsbegleiter nach § 45a SGB XI',
    icon: <Icon><path d="M22 10L12 5 2 10l10 5 10-5z" /><path d="M6 12v5c3 2 9 2 12 0v-5" /></Icon>
  }
];

const TrustBar = () => (
  <section className="trust" aria-label="Vertrauen und Qualität">
    <ul className="trust__list">
      {items.map((item) => (
        <li key={item.id} className="trust__item">
          <span className="trust__icon">{item.icon}</span>
          <span className="trust__text">
            <strong>{item.title}</strong>
            <span>{item.text}</span>
          </span>
        </li>
      ))}
    </ul>
  </section>
);

export default TrustBar;
